module.exports = __webpack_public_path__ + "img/max-file-content-signature-approve.64f5d4ee.svg";